import React from "react";

const BasicDetails = ({ userData }) => {
    return (
        <div className="bg-white rounded shadow-sm w-100 mb-3 overflow-hidden" style={{ height: "300px" }}>
            <div className="p-3">
                <div className="row">
                    <div className="col-md-4 mb-3">
                        <label className="form-label text-muted  mb-1 fw-normal">Atom ID</label>
                        <div className="fw-semibold text-dark">{userData?.atom_id || "-"}</div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label text-muted  mb-1 fw-normal">Email Address</label>
                        <div className="fw-semibold text-dark text-break">{userData?.email || "-"}</div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label text-muted     mb-1 fw-normal">Phone</label>
                        <div className="fw-semibold text-dark">{(userData?.indivisual || userData?.organization)?.mobile || "-"}</div>
                    </div>

                    <div className="col-md-4 mb-3">
                        <label className="form-label text-muted     mb-1 fw-normal">Pincode</label>
                        <div className="fw-semibold text-dark">{(userData?.indivisual || userData?.organization)?.pincode || "-"}</div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label text-muted     mb-1 fw-normal">City</label>
                        <div className="fw-semibold text-dark">{(userData?.indivisual || userData?.organization)?.city_name || "-"}</div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label text-muted     mb-1 fw-normal">State</label>
                        <div className="fw-semibold text-dark">{(userData?.indivisual || userData?.organization)?.state_name || "-"}</div>
                    </div>

                    <div className="col-md-4 mb-3">
                        <label className="form-label text-muted     mb-1 fw-normal">Country</label>
                        <div className="fw-semibold text-dark">{(userData?.indivisual || userData?.organization)?.country_name || "-"}</div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label text-muted     mb-1 fw-normal">Address</label>
                        <div className="fw-semibold text-dark">{(userData?.indivisual || userData?.organization)?.address || "-"}</div>
                    </div>

                    <div className="col-md-4 mb-3">
                        <label className="form-label text-muted mb-1 fw-normal">User Type</label>
                        <div className="fw-semibold text-dark">{userData?.user_category_main_name || userData?.user_category_main || "-"}</div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label text-muted mb-1 fw-normal">Category</label>
                        <div className="fw-semibold text-dark">{userData?.category_type_name || userData?.category_type || "-"}</div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label text-muted mb-1 fw-normal">Sub-Category</label>
                        <div className="fw-semibold text-dark">{userData?.sub_category_type_name || userData?.sub_category_type || "-"}</div>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default BasicDetails;
